// @flow
import React from 'react';
import {
  MdEmail,
  MdClose,
  MdLocalPhone,
  MdAssignmentInd,
} from 'react-icons/lib/md';
import styles from './contactCard.css';
import User from '../../User/index';
import Button from '../../Button';
import Cell from '../../DataTable/Cells/Text';

type ContactCardPropTypes = {
  firstName: string,
  lastName: string,
  userRole: string,
  phone: string,
  email: string,
  id: number,
  clickAction: Function,
  updateProfile: Function,
  pictureURL?: string,
  editable?: boolean,
};

const ContactCard = ({
  firstName = '',
  lastName = '',
  userRole = '',
  email = '',
  phone = '',
  id = 0,
  updateProfile,
  clickAction,
  pictureURL,
  editable = false,
}: ContactCardPropTypes) => {
  const phoneSplited = phone.split('+502')[1];
  return (
    <div className={styles.contactCard}>
      <Button
        Icon={MdClose}
        isOutlined
        className={styles.closeButton}
        onClick={() => clickAction()}
        isTransparent
        size="medium"
        tint="mediumGray"
      />
      <User
        firstName={firstName}
        lastName={lastName}
        userRole={userRole}
        pictureURL={pictureURL}
        useAsTitle
      />
      <div className={styles.phoneContainer}>
        <MdAssignmentInd className={styles.icon} size={30} />
        {
          editable ? (
            <div className={styles.Cell}>
              <Cell
                value={
                  `${firstName}`
                }
                editable
                original={{ id, email, phoneSplited }}
                onChange={(original, fn) => updateProfile({ id: original.id, first_name: fn })}
              />
            </div>
          ) : (<p className={styles.text}>{phoneSplited}</p>)
        }
      </div>
      <div className={styles.phoneContainer}>
        <MdAssignmentInd className={styles.icon} size={30} />
        {
          editable ? (
            <div className={styles.Cell}>
              <Cell
                value={
                  `${lastName}`
                }
                editable
                original={{ id, email, phoneSplited }}
                onChange={(original, ln) => updateProfile({ id: original.id, last_name: ln })}
              />
            </div>
          ) : (<p className={styles.text}>{phoneSplited}</p>)
        }
      </div>
      <div className={styles.phoneContainer}>
        <MdLocalPhone className={styles.icon} size={30} />
        {
          editable ? (
            <div className={styles.Cell}>
              <Cell
                value={
                  `${phoneSplited}`
                }
                editable
                original={{ id, email, phoneSplited }}
                onChange={(original, new_phone) => updateProfile({
                  id: original.id,
                  phone: new_phone,
                })}
              />
            </div>
          ) : (<p className={styles.text}>{phoneSplited}</p>)
        }
      </div>
      <div className={styles.emailContainer}>
        <MdEmail className={styles.icon} size={30} />
        {
          editable ? (
            <div className={styles.Cell}>
              <Cell
                value={
                `${email}`
              }
                editable
                original={{ id, email, phoneSplited }}
                onChange={(original, new_email) => updateProfile({
                  id: original.id,
                  email: new_email,
                })}
              />
            </div>
          ) : (<p className={styles.text}>{email}</p>)
        }
      </div>
    </div>
  )
};

export default ContactCard;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentCard/ContactCard/index.jsx